export const VIEWS = {
  LANDING: "landing",
  WIDGET: "widget-container",
};

export const URLS = {
  PC_COMPONENTES_INSURANCE:
    "https://www.pccomponentes.com/pccare-seguro-obligatorio-de-responsabilidad-civil",
};
